import AtriumApi from "api";
import DarkButton from "components/actions/DarkButton";
import GrayButton from "components/actions/GrayButton";
import InputField from "components/fields/InputField";         
import { Formik, Form } from "formik";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import * as Yup from "yup";

const PlanningCenterLogo = () => {
  return (
    <svg
      className="inline-block"
      width="28"
      height="30"
      viewBox="0 0 28 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_690_12969)">
        <path
          d="M24.7852 3.27941C26.7556 3.79412 28 5.64706 28 7.60294V21.2941C28 23.25 26.6519 25 24.7852 25.6176L16.2815 28.1912C14.8296 28.6029 13.1704 28.6029 11.7185 28.1912L3.21481 25.7206C1.34815 25.1029 0 23.25 0 21.2941V7.60294C0 5.64706 1.34815 3.89706 3.21481 3.27941L11.7185 0.808824C13.1704 0.397059 14.8296 0.397059 16.2815 0.808824L24.7852 3.27941Z"
          fill="#2565F4"
        />
        <path
          d="M18.5 9.30005L13.7 10.7001C13.5 10.7001 13.4 10.8001 13.2 10.7001L8.4 9.30005C7.4 9.00005 6.5 9.70005 6.5 10.7001V21.5001C6.5 21.7001 6.6 21.9001 6.8 21.9001L8.6 22.4001C8.9 22.5001 9.1 22.3001 9.1 22.0001V19.5001C9.1 19.5001 9.1 19.4001 9.2 19.4001L12.8 20.5001C13.3 20.6001 13.8 20.6001 14.2 20.5001L19.6 18.8001C20.2 18.7001 20.5 18.3001 20.5 17.8001V10.8001C20.5 9.80005 19.5 9.00005 18.5 9.30005ZM17.9 16.5001C17.9 16.6001 17.8 16.7001 17.7 16.7001L13.8 17.9001C13.6 18.0001 13.4 18.0001 13.2 17.9001L9.4 16.8001C9.3 16.8001 9.2 16.7001 9.2 16.6001V12.6001C9.2 12.5001 9.3 12.4001 9.5 12.4001L12.6 13.3001C13.2 13.5001 13.9 13.5001 14.5 13.3001L17.6 12.4001C17.7 12.4001 17.9 12.5001 17.9 12.6001V16.5001Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_690_12969">
          <rect
            width="28"
            height="29"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const IntegrationSetting = () => {
  const currentUrl =
    window.location.origin + "/admin/pc-integration-redirecting";

  const [initialValues, setInitialValues] = useState({
    clientId: "",
    clientSecret: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchPlanningCenterKeys = async () => {
      try {
        const response = await AtriumApi.get("/v1/planning-center-keys");
        if (response) {
          setInitialValues({
            clientId: response?.data?.planningCenterKeys?.clientId || "",
            clientSecret:
              response?.data?.planningCenterKeys?.clientSecret || "",
          });
        }
      } catch (error) {
        console.log("fetching all campuses error", error);
      }
    };
    fetchPlanningCenterKeys();
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(currentUrl);
    toast.success("Copied to clipboard.");
  };

  return (
    // <div className="w-[600px] rounded-[30px] p-3 md:p-[30px] gap-[30px] shadow-atrium shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none mb-5">
    //   <div className="w-full flex flex-row gap-3 items-start">
    //     <span className="flex items-center justify-center w-[56px] h-[56px] bg-gray-100 rounded-2xl">
    //       <PlanningCenterLogo />
    //     </span>

    //     <div className="flex-1">
    //       <h2 className="font-bold text-xl mb-1">Planning Center</h2>
    //       <p className="text-sm text-gray-700">Integration setting</p>
    //     </div>
    //   </div>

    //   <Formik
    //     enableReinitialize
    //     initialValues={initialValues}
    //     validationSchema={Yup.object({
    //       clientId: Yup.string().required("Client ID is required"),
    //       clientSecret: Yup.string().required("Client Secret is required"),
    //     })}
    //     onSubmit={async (values) => {
    //       setIsLoading(true);
    //       try {
    //         const response = await AtriumApi.post("/v1/planning-center-keys", {
    //           ...values,
    //           redirectUri: currentUrl,
    //         });
    //         if (response) {
    //           toast.success("Planning center keys updated successfully.");
    //         }
    //       } catch (error) {
    //         toast.error("Failed to update planning center keys.");
    //       } finally {
    //         setIsLoading(false);
    //       }
    //     }}
    //   >
    //     {({
    //       values,
    //       errors,
    //       touched,
    //       handleChange,
    //       handleBlur,
    //       handleSubmit,
    //     }) => (
    //       <Form onSubmit={handleSubmit}>
    //         <div className="space-y-4 mt-4">
    //           <InputField
    //             label="Client ID"
    //             name="clientId"
    //             value={values.clientId}
    //             onChange={handleChange}
    //             onBlur={handleBlur}
    //             error={errors.clientId}
    //             touched={touched.clientId}
    //             variant="auth"
    //             placeholder="Client ID"
    //           />

    //           <InputField
    //             label="Client Secret"
    //             name="clientSecret"
    //             value={values.clientSecret}
    //             onChange={handleChange}
    //             onBlur={handleBlur}
    //             error={errors.clientSecret}
    //             touched={touched.clientSecret}
    //             variant="auth"
    //             placeholder="Client Secret"
    //           />

    //           <div className="flex items-end gap-2 m">
    //             <div className="flex-1">
    //               <InputField
    //                 label="Redirect URL (Please add following URL in your authorized callback URL in your planning center application)"
    //                 type="text"
    //                 placeholder="Redirect URL"
    //                 variant="auth"
    //                 value={currentUrl}
    //                 disabled
    //               />
    //             </div>
    //             <GrayButton size="lg" type="button" onClick={handleCopy}>
    //               Copy
    //             </GrayButton>
    //           </div>
    //         </div>

    //         <div className="mt-4">
    //           <DarkButton size="lg" type="submit" disabled={isLoading}>
    //             {isLoading ? "Saving..." : "Save"}
    //           </DarkButton>
    //         </div>
    //       </Form>
    //     )}
    //   </Formik>
    // </div>

    <div className="flex flex-col md:flex-row gap-6">
      {/* Left Section: Planning Center Form */}
      <div className="w-full md:w-[60%] rounded-[30px] p-3 md:p-[30px] gap-[30px] shadow-atrium shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none mb-5">
        <div className="w-full flex flex-row gap-3 items-start">
          <span className="flex items-center justify-center w-[56px] h-[56px] bg-gray-100 rounded-2xl">
            <PlanningCenterLogo />
          </span>
          <div className="flex-1">
            <h2 className="font-bold text-xl mb-1">Planning Center</h2>
            <p className="text-sm text-gray-700">Integration setting</p>
          </div>
        </div>

        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={Yup.object({
            clientId: Yup.string().required("Client ID is required"),
            clientSecret: Yup.string().required("Client Secret is required"),
          })}
          onSubmit={async (values) => {
            setIsLoading(true);
            try {
              const response = await AtriumApi.post(
                "/v1/planning-center-keys",
                {
                  ...values,
                  redirectUri: currentUrl,
                }
              );
              if (response) {
                toast.success("Planning center keys updated successfully.");
              }
            } catch (error) {
              toast.error("Failed to update planning center keys.");
            } finally {
              setIsLoading(false);
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => (
            <Form onSubmit={handleSubmit}>
              <div className="space-y-4 mt-4">
                <InputField
                  label="Client ID"
                  name="clientId"
                  value={values.clientId}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.clientId}
                  touched={touched.clientId}
                  variant="auth"
                  placeholder="Client ID"
                />

                <InputField
                  label="Client Secret"
                  name="clientSecret"
                  value={values.clientSecret}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.clientSecret}
                  touched={touched.clientSecret}
                  variant="auth"
                  placeholder="Client Secret"
                />

                <div className="flex items-end gap-2">
                  <div className="flex-1">
                    <InputField
                      label="Redirect URL (Please add the following URL in your authorized callback URL in your Planning Center application)"
                      type="text"
                      placeholder="Redirect URL"
                      variant="auth"
                      value={currentUrl}
                      disabled
                    />
                  </div>
                  <GrayButton size="lg" type="button" onClick={handleCopy}>
                    Copy
                  </GrayButton>
                </div>
              </div>

              <div className="mt-4">
                <DarkButton size="lg" type="submit" disabled={isLoading}>
                  {isLoading ? "Saving..." : "Save"}
                </DarkButton>
              </div>
            </Form>
          )}
        </Formik>
      </div>

      {/* Right Section: Instructions */}
      <div className="w-full md:w-[40%] rounded-[30px] p-6 bg-white dark:bg-navy-800 shadow-sm border border-gray-200 dark:border-gray-700 h-fit">
        <h3 className="text-lg font-bold mb-3 text-center">Instructions</h3>
        <h4 className="font-bold mt-6">How to make connection</h4>
        <p className="text-sm text-gray-700 dark:text-gray-300">
          Using redirect URI, create an app in the{" "}
          <strong>Planning Center Developer Portal</strong> to get the{" "}
          <strong>Client ID</strong> and <strong>Client Secret</strong>, and
          attach these keys in integration settings.
        </p>

        <h4 className="font-bold mt-6">How to remove the app</h4>
        <p className="text-sm text-gray-700 dark:text-gray-300 mt-2">
          To remove the app, delete it from the Developer Portal. To revoke
          access, go to your Planning Center profile under{" "}
          <strong>"Authorized apps"</strong> and <strong>"Applications"</strong>
          .
        </p>
      </div>
    </div>
  );
};

export default IntegrationSetting;
